import { useState } from 'react'
import { Link } from 'react-router-dom'

import { Space, Button } from 'antd'
import * as Icons from '@ant-design/icons'
import styled from 'styled-components'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'

import { CompaniesList } from './CompaniesList_v2'
import {
  CompanyModal,
  ManufacturerCompanyModalWrapper,
  SupplierCompanyModalWrapper
} from './CompanyModal'

export function Companies_v2() {
  const [companyModalOpen, setCompanyModalOpen] = useState(false)
  const [editCompany, setEditCompany] = useState<{
    id: string
    isManufacturer: boolean
    hasMatch: boolean
  } | null>(null)

  const handleEdit = (
    companyId: string,
    isManufacturer: boolean,
    hasMatch: boolean
  ) => {
    setEditCompany({ id: companyId, isManufacturer, hasMatch })
    setCompanyModalOpen(true)
  }

  const handleModalClose = () => {
    setEditCompany(null)
    setCompanyModalOpen(false)
  }

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              { title: 'Reference Data' },
              {
                title: (
                  <Link to={ROUTES.REFERENCE_DATA.INDEX}>
                    Suppliers and Manufacturers
                  </Link>
                )
              }
            ]}
          />

          <Space>
            <Button
              icon={<Icons.FolderAddOutlined />}
              type="primary"
              onClick={() => setCompanyModalOpen(true)}
            >
              New
            </Button>
          </Space>
        </>
      }
    >
      <CompaniesListWrapper>
        <CompaniesList onEdit={handleEdit} />
      </CompaniesListWrapper>
      <>
        {!editCompany && (
          <CompanyModal open={companyModalOpen} onClose={handleModalClose} />
        )}

        {editCompany && editCompany.isManufacturer && (
          <ManufacturerCompanyModalWrapper
            open={companyModalOpen}
            onClose={handleModalClose}
            company={editCompany}
          />
        )}

        {editCompany && !editCompany.isManufacturer && (
          <SupplierCompanyModalWrapper
            open={companyModalOpen}
            onClose={handleModalClose}
            company={editCompany}
          />
        )}
      </>
    </Layout>
  )
}

const CompaniesListWrapper = styled.div`
  margin: 0.5rem 0.5rem 0 0.5rem;
  width: 100%;
`
